import React, { Component } from 'react';
import { connect } from 'react-redux';
import { errorMessages, loggerEventName, loggerEventOutcome, loggerEventTypes, successMessages, deviceMessages } from '../../../helpers/messages';
import { logger } from '../../../services/logger/logger-service';
import DeviceDetailsUploadComponent from './DeviceDetailsUpload';
import { uploadDeviceSDAFile } from '../../../services/java/java-services'
let startDate;
const MAX_FILE_SIZE = 1073741824; // 1GB size
class DeviceDetailsUploadContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uploadError: '',
			isLoading: false,
			uploadSuccess: false,
			selectedFiles: '',
			fileExtentionError: false,
			maxFileSizeError: false,
			displayFileName: '',
			disclaimerCheckBoxValue: false,
			isFileUploading: false,
			errors: {
				fileName: '',
				disclaimerCheckBox:""
			}
		}
	}

	componentDidMount() {
		// initialize the start date on page load
		startDate = new Date();
		window.addEventListener('beforeunload', this.applicationLogger);
	}
	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.applicationLogger);
		this.applicationLogger();
	}
	/**
	 * @description function to handle application logs
	 * @param {*}
	 * @memberof DeviceDetailsUploadContainer
	 */
	applicationLogger(key) {
		// calculate the time since we loaded this page
		const timeSinceLoad = (new Date().getTime() - startDate.getTime()) / 1000;
		const loggerObj = {
			"EventOutcome": loggerEventOutcome.success,
			"EventType": loggerEventTypes.read,
			"EventName": loggerEventName.sdaUpload,
			"Content": {
				"TimeSpent": timeSinceLoad
			}
		}
		logger(loggerObj);
	}

	/**
	 * @description function for file upload form 
	 * @param {*}
	 * @memberof DeviceDetailsUploadContainer
	 */
	formValidation() {
		var errors = { ...this.state.errors };
		const { selectedFiles } = this.state;
		// File validation
		if (selectedFiles === '' || !selectedFiles) {
			errors.fileName = deviceMessages.selectTextFile;
			this.setState({ errors })
			return errors;
		} else {
			errors.fileName = '';
			this.setState({ errors })
		}

		// File size validation
		if (selectedFiles) {
			let getFileSize = selectedFiles[0]['size'];
			if (getFileSize > MAX_FILE_SIZE) {
				return false;
			}
		}

		// File upload confirm checkbox validation
		if (this.state.disclaimerCheckBoxValue === false) {
			errors.disclaimerCheckBox = errorMessages.fileUpload.disclaimerCheckBox;
			this.setState({ errors })
			return errors;
		} else {
			errors.disclaimerCheckBox = '';
			this.setState({ errors })
		}
		return true;
	}

	/**
	 * @description function to verify file properties like size, file extention etc..
	 * @param  {} selectedFile
	 * @memberof DeviceDetailsUploadContainer
	 */
	handleChange = async (selectedFile) => {
		if (!selectedFile[0]) return;
		var errors = { ...this.state.errors }
		let getFileName = selectedFile[0]['name'];
		let getExtension = getFileName.split('.').pop();
		let getFileSize = selectedFile[0]['size'];
		this.setState({
			displayFileName: getFileName,
			uploadError: '',
		});
		// to reset validation
		errors.fileName = '';
		this.setState({ errors })
		if (getExtension === 'txt') {
			this.setState({
				selectedFiles: selectedFile,
				fileExtentionError: false, 
				maxFileSizeError: false
			});
		} else {
			this.setState({ fileExtentionError: true });
		}
		if (getFileSize > MAX_FILE_SIZE) {
			this.setState({ maxFileSizeError: true });
		}
	}

	/** @description function to handle field disclaimer box chnages
	 *  @param  {} event
	 *  @memberof DeviceDetailsUploadContainer
	 */
	disclaimerCheckBoxChange = (event) => {
		var errors = { ...this.state.errors }
		if (event.target.checked) {
			errors.disclaimerCheckBox = '';
			this.setState({ errors, disclaimerCheckBoxValue: true });
		} else {
			errors.disclaimerCheckBox = errorMessages.fileUpload.disclaimerCheckBox;
			this.setState({ errors, disclaimerCheckBoxValue: false });
		}
	}

	/** 
	 *  @description function to handle submit action 
	 *  @param  {}
	 *  @memberof DeviceDetailsUploadContainer
	 */
	uploadSubmit = async () => {
		this.setState({ uploadError: '' });
		let verifyValidation = this.formValidation();
		if (verifyValidation === true) {
			let formData = new  FormData()
			formData.set('filename', this.state.selectedFiles[0])
			formData.set('serialno',this.props.deviceDetails.details.serialNo)

			this.setState({ isFileUploading: true });
			uploadDeviceSDAFile(formData, (err,response)=> {
				if(err) {
                    this.setState({ isFileUploading: false, uploadError: err.errorMessage });
				} else {
 					this.setState({ isFileUploading: false, uploadSuccess: true, displayFileName: '', selectedFiles: '', disclaimerCheckBoxValue: false });

					this.props.handleUploadSuccess();
				}
			})
		}
	}

	/** 
	 *  @description function to handle reset Input value after form submit 
	 *  @param  {}
	 *  @memberof DeviceDetailsUploadContainer
	 */
	resetInput = (selectedFile) => {
		selectedFile.target.value = null;
		this.setState({ uploadSuccess: false, displayFileName: '', selectedFiles: '' })
	}

	render() {
		const { toggleUploadModal } = this.props;
		const { isFileUploading, disclaimerCheckBoxValue, isLoading, uploadError, errors, displayFileName, fileExtentionError, maxFileSizeError,
			 uploadSuccess } = this.state;
		return (
			<DeviceDetailsUploadComponent
				onSubmit={this.uploadSubmit}
				onInputChange={this.handleChange}
				isFileUploading={isFileUploading}
				disclaimerCheckBoxChange={this.disclaimerCheckBoxChange}
				disclaimerCheckBoxValue={disclaimerCheckBoxValue}
				successMsgs={successMessages}
				isLoading={isLoading}
				uploadError={uploadError}
				formErrors={errors}
				displayFileName={displayFileName}
				fileExtentionError={fileExtentionError}
				maxFileSizeError={maxFileSizeError}
				uploadSuccess={uploadSuccess}
				resetInput={this.resetInput}
				toggleUploadModal={toggleUploadModal}
			/>
		);
	}
}

function mapStateToProps(state) {
	return {
		state,
	};
}

export default connect(mapStateToProps)(DeviceDetailsUploadContainer);
